import React from 'react'
import { Map, List } from 'immutable'
import { connect as connectRedux } from 'react-redux'
import { getBoundActions } from '../../../actions/index'
import { COURSE_STATE_NOT_STARTED } from '../../../services/detail/index'
import DetailPageV3Description from '../DetailPageV3Description'
import DetailPageV3InfoMeta from '../DetailPageV3InfoMeta'
import DetailPageV3Info from '../DetailPageV3Info'
import DetailPageV3CourseModules from './DetailPageV3CourseModules'

/**
   * Course detail page overview tab component
 * @param {Object} props - The props
 * @param {Map} props.detailData - The content details data
 * @param {List} props.modulesData - The course modules data
 * @param {Map} props.featuredContent - The featured content data
 * @param {Map} props.progressData - The course progress data
 * @param {function} props.onCourseStateChange - The function to handle course state change
 * @param {Map} props.staticText - The static text data
 * @returns {JSX.Element} DetailPageV3CourseOverview
 */

const DetailPageV3CourseOverview = (props) => {
  const {
    detailData = Map(),
    modulesData = List(),
    featuredContent = Map(),
    staticText,
    progressData = Map(),
    onCourseStateChange,
  } = props

  const courseState = progressData.get('state')

  const courseContentId = detailData.get('contentId')

  return (
    <div className="detail-page-v3__course-overview">
      <DetailPageV3Info
        text={detailData.get('description')}
        moreButtonLabel={staticText.get('moreInfo')}
        defaultExpanded={courseState === COURSE_STATE_NOT_STARTED}
      >
        <>
          <DetailPageV3Description description={detailData.get('description')} />
          <DetailPageV3InfoMeta detailData={detailData} featuredContent={featuredContent}/>
        </>
      </DetailPageV3Info>

      <DetailPageV3CourseModules
        modulesData={modulesData}
        progressData={progressData}
        courseContentId={courseContentId}
        onCourseStateChange={onCourseStateChange}
      />
    </div>
  )
}

export default connectRedux((state) => ({
  staticText: state.staticText.getIn(['data', 'detailPageV3', 'data'], Map()),
}), (dispatch) => {
  const actions = getBoundActions(dispatch)
  return {
    setEventDefault: actions.eventTracking.setEventDefault,
  }
})(DetailPageV3CourseOverview)
